import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ServiceOffer, CartItem} from '../../../../data/model';
import {ServiceOfferFormComponent} from '../service-offer-form';

interface ServiceOfferCheckBoxForm {
  addItemToCart: FormControl<boolean | null>;
}

@Component({
  selector: 'app-checkbox-form',
  templateUrl: './checkbox-form.component.html',
  styleUrls: ['./checkbox-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // JMB [2023-05-12]: Breaking with convention so that the styles don't overlap with the old.
  host: {class: 'app-checkbox-form-component'},
  standalone: false,
})
export class CheckboxFormComponent extends ServiceOfferFormComponent {
  @Input() serviceOffer: ServiceOffer;

  offerForm = new FormGroup<ServiceOfferCheckBoxForm>({
    addItemToCart: new FormControl<boolean>(false),
  });

  constructor(protected ref: ChangeDetectorRef) {
    super(ref);
    this.offerForm.valueChanges.subscribe(() => this.ref.detectChanges());
  }

  get agreementLabel(): string {
    return this.serviceOffer?.inputLabels?.[0] || '';
  }

  get addItemToCartControl(): FormControl<boolean> {
    return this.offerForm.get('addItemToCart') as FormControl;
  }

  addonSelected(): boolean {
    return !!this.offerForm && !!this.offerForm.value.addItemToCart;
  }

  bindFormValue(selected: boolean): void {
    this.offerForm.setValue({addItemToCart: selected});
  }

  valid(): boolean {
    return super.valid();
  }

  value(): CartItem {
    return super.value();
  }
}
